import { useRef as e } from "react";
//#region src/hooks/useMobileSwipe.ts
function t({ onSwipe: t, threshold: n = 50 }) {
	let r = e(null);
	return {
		onTouchStart: (e) => {
			r.current = {
				x: e.touches[0].clientX,
				y: e.touches[0].clientY
			};
		},
		onTouchEnd: (e) => {
			if (!r.current) return;
			let i = e.changedTouches[0].clientX - r.current.x, a = e.changedTouches[0].clientY - r.current.y;
			Math.abs(i) > Math.abs(a) ? i < -n ? t("left") : i > n && t("right") : a < -n ? t("top") : a > n && t("bottom"), r.current = null;
		}
	};
}
//#endregion
export { t as useMobileSwipe };
